import {useLocation, useSearch} from 'wouter';

import {EditModeTab, QueriesTab, ViewModeTab} from './layout-typings';
import type {ActivityBarTabs, LayoutType} from './layout-typings';

function layoutHasTab(layout: LayoutType, tab: string): tab is ActivityBarTabs {
    const availableTabList = (function () {
        if (layout === 'explore') {
            return ViewModeTab;
        }

        if (layout === 'edit') {
            return EditModeTab;
        }

        return QueriesTab;
    })();

    return Object.values(availableTabList).includes(tab);
}

/** Encapsulates functionality which redirects user to page with tabs
 * (document view, document edit or queries) with preselected tab */
export function usePreselectedTab() {
    const [pathname, navigate] = useLocation();
    const search = useSearch();

    function getPreselectedTabURLParam(tabName: ActivityBarTabs) {
        return `tab=${tabName}`;
    }

    function getPreselectedTabFromUrl(layout: LayoutType) {
        const tab = new URLSearchParams(search).get('tab');
        if (!tab || !layoutHasTab(layout, tab)) {
            return null;
        }

        return tab;
    }

    function clearPreselectedTab() {
        const params = new URLSearchParams(search);
        params.delete('tab');
        navigate(`${pathname}${params.toString() ? `?${params.toString()}` : ''}`, {replace: true});
    }

    return {getPreselectedTabURLParam, getPreselectedTabFromUrl, clearPreselectedTab};
}
